import { Navigate, Route, Routes } from 'react-router-dom';
import { CreatePassword } from 'src/screen/create-password/create-password';
import { HaulierSignUpScreen } from 'src/screen/haulier-sign-up/haulier-sign-up-screen';
import { HaulierSingUpStepScreen } from 'src/screen/haulier-sign-up/haulier-sing-up-step-screen';
import { HomeScreen } from 'src/screen/home-screen';
import { LoginScreen } from 'src/screen/login-screen/login-screen';
import { LogoutScreen } from 'src/screen/logut-screen';
import { NotVerifiedScreen } from 'src/screen/not-verified-screen/not-verified-screen';
import { ResetPassword } from 'src/screen/reset-password/reset-password';
import { TestScreen } from 'src/screen/test-screen';
import { VerifyEmail } from 'src/screen/verify-email/verify-email';
import { ProtectedAuthOnlyRoute } from 'src/util/protected-auth-only-route';
import { ProtectedUnAuthOnlyRoute } from 'src/util/protected-un-auth-only-route';

export const Router = (): JSX.Element => {
	return (
		<Routes>
			{/*PUBLIC*/}
			<Route
				path="/verify/:code"
				element={<VerifyEmail />}
			/>
			<Route
				path="/logout"
				element={<LogoutScreen />}
			/>
			<Route
				path="/login"
				element={<LoginScreen />}
			/>
			<Route
				path="/signup/steps"
				element={<HaulierSingUpStepScreen />}
			/>
			{/*UN AUTHORISED*/}
			<Route
				path="/signup"
				element={<ProtectedUnAuthOnlyRoute children={<HaulierSignUpScreen />} />}
			/>
			<Route
				path="/reset-password"
				element={<ProtectedUnAuthOnlyRoute children={<ResetPassword />} />}
			/>
			<Route
				path="/create-password/:tempCode"
				element={<ProtectedUnAuthOnlyRoute children={<CreatePassword />} />}
			/>

			{/*/AUTHORISED ONLY*/}
			<Route
				path="/"
				element={<ProtectedAuthOnlyRoute children={<HomeScreen />} />}
			/>
			<Route
				path="/not-verified"
				element={<ProtectedAuthOnlyRoute children={<NotVerifiedScreen />} />}
			/>

			{/* TODO remove test screen used for testing refresh-token*/}
			<Route
				path="/test"
				element={<ProtectedAuthOnlyRoute children={<TestScreen />} />}
			/>

			{/*CATCH ALL*/}
			<Route
				path="*"
				element={
					<Navigate
						replace
						to="/"
					/>
				}
			/>
		</Routes>
	);
};
